import Vue from 'vue'
import Router from 'vue-router'

const MasksList = () => import(/* webpackChunkName: 'masklist' */ '@/components/MasksList')
const FAQ = () => import(/* webpackChunkName: 'faq' */ '@/components/FAQ')
const EditMask = () => import(/* webpackChunkName: 'editmask' */ '@/components/EditMask')
const Admin = () => import(/* webpackChunkName: 'admin' */ '@/components/Admin')
const Login = () => import(/* webpackChunkName: 'login' */ '@/components/Login')
const ReservationAdmin = () => import(/* webpackChunkName: 'reservationadmin' */ '@/components/admin/ReservationAdmin')
const ReservationList = () => import(/* webpackChunkName: 'reservationlist' */ '@/components/ReservationList')
const WebSettings = () => import(/* webpackChunkName: 'websettings' */ '@/components/admin/WebSettings')

import {auth} from '../firebase/firebaseConfig.js'
import {store} from '../store/store.js'
Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/masks'
    },
    {
      path: '/masks',
      name: 'MasksList',
      component: MasksList
    },
    {
      path: '/faq',
      name: 'FAQ',
      component: FAQ
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/setup',
      name: 'setup',
      component: WebSettings,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/reservations',
      name: 'reservationadmin',
      component: ReservationAdmin,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/mylist',
      name: 'reservationlist',
      component: ReservationList
    },
    {
      path: '/editmask/:id',
      name: 'editmask',
      component: EditMask,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '*',
      redirect: '/'
    },
  ]
})
router.beforeEach((to, from, next) => {
  const currentUser = auth.currentUser && auth.currentUser.uid
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  store.commit('setCurrentRoute', to.name)
  if (requiresAuth && !currentUser) next('login')
  else next()
})
export default router;
